import React, { useEffect, useState } from 'react';

import { GroupingsService } from '../../services';
import PageTitle from '../PageTitle/page_title';
import ChecklistSummaryReportForm from './checklist_summary_report_form';
import ChecklistSummaryReportResults from './checklist_summary_report_results';
import i18next from "i18next";

const ChecklistSummaryReport = () => {
  const [errorMessage, setErrorMessage] = useState(null);
  const [availableGroupingValues, setAvailableGroupingValues] = useState(null);
  const [query, setQuery] = useState(null);

  useEffect(() => {
    setErrorMessage(null);

    GroupingsService.listAll().then((response) => {
      const leafGroupings = response.groupings
                    .filter((grouping) => grouping.deviceGroup?.children?.length == 0)
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((grouping) => ({ value: grouping.id, label: grouping.name, grouping: grouping }));

      setAvailableGroupingValues(leafGroupings);
    }).catch((error) => {
      setErrorMessage(i18next.t('messages.could-not-load-groupings'));
      console.error(error);
    });
  }, []);

  if (availableGroupingValues) {

    return (
        <div>
          <div className="row">
            <PageTitle title={ i18next.t('pages.weekly-checklist-summary-report.header') } />
          </div>
          { errorMessage && <div>{errorMessage}</div> }
          <div className="device-detail-report col-sm-12">
            <ChecklistSummaryReportForm groupingValues={ availableGroupingValues } onSubmit={setQuery} />
          </div>
          <div className = "device-detail-report col-sm-12">
            { query && <ChecklistSummaryReportResults query={query} /> }
          </div>
        </div>
    );

  } else {
    return (<div className="loader">{ i18next.t('loading') }</div>);
  }
}

export default ChecklistSummaryReport;
